import React from "react";

import { Container, Row } from "reactstrap";
import { BsListTask, BsCheckBox } from "react-icons/bs";
import { IoIosImage } from "react-icons/io";
import { AiOutlineHome } from "react-icons/ai";
import { GoMail } from "react-icons/go";

const DalabaEstateSection = () => {
  return (
    <div>
      <section className="section-wrap relative bg-dark pb-md-120" id="dalaba">
        <Container>
          <div className="heading-row text-center">
            <h2 className="heading heading-large bottom-line">DALABA ESTATE</h2>
          </div>
          <Row>
            <div className="tabs feature-tabs">
              <ul className="feature-tabs-icons">
                <li className="active col-md-5ths text-center">
                  <a
                    href="#tab-1"
                    className="feature-tabs-link tabs-link-trigger"
                    aria-label="See list of Estates"
                  >
                    <BsListTask className="feature-tabs-icon" />
                    THE ESTATE
                  </a>
                </li>
                <li className="col-md-5ths text-center">
                  <a
                    href="#tab-2"
                    className="feature-tabs-link tabs-link-trigger"
                    aria-label="View features and facilities"
                  >
                    <BsCheckBox className="feature-tabs-icon" />
                    FEATURES &amp; FACILITIES
                  </a>
                </li>
                <li className="col-md-5ths text-center">
                  <a
                    href="#tab-3"
                    className="feature-tabs-link tabs-link-trigger"
                    aria-label="View list of images of our estate"
                  >
                    <IoIosImage className=" feature-tabs-icon" />
                    MULTIMEDIA
                  </a>
                </li>
                <li className="col-md-5ths text-center">
                  <a
                    href="#tab-4"
                    className="feature-tabs-link tabs-link-trigger"
                    aria-label="View our mortgage plans"
                  >
                    <AiOutlineHome className="feature-tabs-icon" />
                    MORTGAGE
                  </a>
                </li>
                <li className="col-md-5ths text-center">
                  <a
                    href="#tab-5"
                    className="feature-tabs-link tabs-link-trigger"
                    aria-label="View contact details"
                  >
                    <GoMail className=" feature-tabs-icon" />
                    GET IN TOUCH
                  </a>
                </li>
              </ul>
            </div>
          </Row>
        </Container>
      </section>
      <section className="section-wrap feature-tabs-section overlap-offset-top bg-light">
        <div className="container overlap-offset-top-container">
          <div
            className="feature-tabs-content tabs-content-trigger"
            style={{ boxShadow: "1px  1px 20px" }}
          >
            <div className="feature-tabs-content-pane active" id="tab-1">
              <div className="row">
                <div className="col-md-4">
                  {/* <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3908.9877277258756!2d-16.703273232125248!3d13.379284544687067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec299d7579a8119%3A0xe47550d63bef486f!2sDalaba+Estate!5e1!3m2!1sen!2sgm!4v1529785093638"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen
                    title="Direction to Madiba Mall, Brufut"
                  ></iframe> */}
                </div>
                <div className="col-md-8">
                  <h4 className="feature-tabs-content-title">
                    THE <b>ALL NEW</b> TULIP GARDENS<br></br>
                  </h4>
                  <p>
                    The TAF Tulip Gardens estate is the newest estate launch by
                    TAF Africa Global, in our bid to build 10,000 affordable
                    homes in the Gambia within the next two decades.
                  </p>
                  <a
                    href="#dalaba-estate"
                    aria-label="Read more about our new estate"
                  >
                    MORE ON TULIP GARDENS
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default DalabaEstateSection;
